export default "__VITE_ASSET__798e34c3__"